import { Observable } from 'rxjs';
import { EntityModel } from '@bo-client/shared/models/entityModel';

/** Antwort von `export/ids`: Trefferzahl und höchstens 10.000 IDs in Listenreihenfolge. */
export interface ExportIds {
  total: number;
  ids: number[];
}

export abstract class EntityService {
  baseUrl: string; // e.g. feeder-contract // uri.cmFeederContract

  abstract navigateToCreatePage(params: any);

  abstract navigateToEditPage(id: any);

  abstract loadData(
    id: string,
    master: string,
    number: number,
    number2: number,
    filterModel: { [p: string]: any },
    columnState: any
  ): Observable<{ content: EntityModel[]; totalElements: number }>;

  /**
   * Excel-Export in Teilen, Schritt 1: IDs der gefilterten und sortierten Liste (`export/ids`).
   * Bieten Listen `loadExportIds` und `loadExportRows` an, lädt `app-entity-list-page-v2` den
   * Export in Blöcken mit Fortschritt; sonst über die Schattenliste mit `loadData`.
   */
  loadExportIds?(filterModel: { [p: string]: any }, columnState: any): Observable<ExportIds>;

  /** Excel-Export in Teilen, Schritt 2: Zeilen zu höchstens 1.000 IDs in deren Reihenfolge (`export/rows`). */
  loadExportRows?(ids: number[]): Observable<EntityModel[]>;
}
